import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'Service/api/api';

export const getChatsList = createAsyncThunk(
  `chat/getChatsList`,
  async (category: 'private' | 'group') => {
    try {
      // const response = await api.chat.getChatsList(category);
      // return response.data;
      return api.chat.getChatsList(category);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getChatMessages = createAsyncThunk(
  `chat/getChatMessages`,
  async ({
    category,
    chatID,
  }: {
    category: 'private' | 'group';
    chatID: number;
  }) => {
    try {
      // const response = await api.chat.getChatMessages({ category, chatID });
      // return response.data;
      return api.chat.getChatMessages({ category, chatID });
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);
